import { init, track, Identify, identify } from '@amplitude/analytics-browser';

import { visitorService } from '@/services/visitor.service';

const AMPLITUDE_API_KEY = window.amplitudeApiKey ?? '';
const searchParams = new URLSearchParams(window.location.search);
const urlUserId = searchParams.get('mp_user_id');
const urlDeviceId = searchParams.get('udid');
let userId = urlUserId ?? visitorService.visitorUUID;
const deviceId = urlDeviceId ?? undefined;

if (location.pathname.includes('windows')) {
  if (urlDeviceId) {
    userId = urlDeviceId;
  }
}

export const initAmplitude = () => {
  if (AMPLITUDE_API_KEY) {
    if (location.pathname.includes('windows')) {
      if (urlUserId) {
        const identifyEvent = new Identify();
        identifyEvent.set('user_id', urlUserId);
        identify(identifyEvent);
      }
    }

    init(AMPLITUDE_API_KEY, {
      userId,
      deviceId,
      autocapture: {
        attribution: true,
        pageViews: false,
        sessions: false,
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: false,
        frustrationInteractions: false,
        networkTracking: false,
        webVitals: false,
      },
    });
  }
};

type EventProperties = Record<string, string | number | string[] | number[]>;

let additionalEventProps: EventProperties = {};

export const setAdditionalEventProps = (props: EventProperties) => {
  additionalEventProps = {
    ...additionalEventProps,
    ...props,
  };
};

export const sendAmplitudeEvent = (
  eventName: string,
  eventProperties: EventProperties = {},
) => {
  if (AMPLITUDE_API_KEY) {
    const properties: EventProperties = {
      ...additionalEventProps,
      ...eventProperties,
      event_properties__user_id: userId,
    };

    if (deviceId) {
      properties.event_properties__device_id = deviceId;
    }

    track(eventName, properties);
  }
};
